export default "__VITE_ASSET__C2dpSO_X__"